import {
  type Provider,
  ConditionOperatorEnum,
  type Condition,
} from '@repo/api-gw-sdk';

export const createCloudProviderCondition = (
  values: Provider[]
): Condition => ({
  // todo: change to cloudProvider.name once server change the property name.
  // once done, remove also cloud property from accessorMappingAlternatives.
  // property: cloudProvider.name,
  property: 'cloud',
  operator: ConditionOperatorEnum.In,
  value: values,
});
